var map = {
	"./agricultural-sciences.svg": "dc2e",
	"./computer.svg": "e617",
	"./drug-design.svg": "bb24",
	"./energy-technology.svg": "d41d",
	"./humanities-arts.svg": "bf0b",
	"./life-sciences.svg": "b83c",
	"./medical-health.svg": "6b3e",
	"./natural-sciences.svg": "d453",
	"./other.svg": "98b1",
	"./physical-science.svg": "e35a",
	"./social-sciences.svg": "2c5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11e9";